'use client';

import {
  KanbanBoard,
  KanbanCard,
  KanbanCards,
  KanbanHeader,
} from '@/components/ui/shadcn-io/kanban';
import { format} from 'date-fns';
import { useGetList } from 'react-admin';
import CommonKanban from '@/components/common/Kanban';
import { useState } from 'react';
import InvoiceDetail from './InvoiceDetails';

const exampleStatuses = [
  { id: '1', name: 'Not Paid', color: '#fc0313' }, 
  { id: '2', name: 'Paid', color: '#10B981' },
];

const InvoiceKanban = () => {
  const {data = []} = useGetList("auto-service-invoices")
  const [detailsOpen, setDetailsOpen] = useState(false)
  const [row, setRow] = useState<Invoice | null>(null)

  return (
    <>
      <CommonKanban statuses={exampleStatuses} resource='auto-service-invoices'>
        {exampleStatuses.map((status) => (
        <KanbanBoard key={status.name} id={status.name}>
          <KanbanHeader name={status.name} color={status.color} />
          <KanbanCards>
            {data.length > 0 && data
              .filter((feature: invoice) => feature.status === status.name)
              .map((feature: invoice, index) => (
                <KanbanCard
                  key={feature.id}
                  id={"" + feature.id}
                  name={feature.clientRef.name}
                  parent={status.name}
                  index={index}
                >
                  <div className="w-full flex items-start justify-between gap-2">
                    <div className="flex flex-col gap-1">
                      <p className="m-0 flex-1 font-medium text-sm">
                        {feature.clientRef.name}
                      </p>
                      <p className="m-0 text-muted-foreground text-xs">
                        {feature.total}$
                      </p>
                    </div>
                    <p className="justify-self-end m-0 font-medium text-sm overflow-hidden text-clip">
                      {feature.vehicleRef.vin}
                    </p>
                  </div>
                  <p className="m-0 text-muted-foreground text-xs">
                    {format(feature.date, "yyyy-MM-dd")}
                  </p>
                </KanbanCard>
              ))}
          </KanbanCards>
        </KanbanBoard>
      ))}
    </CommonKanban>
    {detailsOpen && <InvoiceDetail open={detailsOpen} setOpen={setDetailsOpen} row={row} />}
    </>
  );
};

export default InvoiceKanban;